import styled from 'styled-components'

export const Wrapper = styled.section`
	padding: 120px 20px 60px;
`

export const IntroContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	max-width: 800px;
	margin: 0 auto 20px;
`

export const IntroSeparator = styled.img`
	width: clamp(75px, 25%, 160px);
	margin: 0 20px;
`

export const IntroItem = styled.figure`
	flex: 1;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
`

export const IntroImageWrapper = styled.div`
	position: relative;
`

export const IntroImage = styled.img`
	max-width: 240px;
	width: 100%;
	height: auto;
`

export const IntroName = styled.figcaption`
	text-align: center;
	margin-top: 30px;
	font-family: 'Trajan Pro', sans-serif;
	font-weight: bold;
	font-size: 1.4rem;
	color: #555;
`

export const IntroBowtie = styled.img`
	position: absolute;
	width: 25%;
	bottom: 0;
	left: 50%;
	transform: translate(-50%, 50%);
`

export const IntroBouquet = styled.img`
	position: absolute;
	bottom: 0;
	right: 0;
	width: 25%;
	transform: rotate(20deg);
`

export const IntroText = styled.p`
	text-align: center;
	color: #888888;
	font-family: 'Roboto Serif', serif;
`
